import { fetch } from 'store/sagas/request';

//************************************ 파일 관련 ************************************//
/**
 * 파일 다운로드
 * @param {*} url 
 * @param {*} options 
 * @param {*} fileName 
 * @param {*} previewTagId  값이 있으면 미리보기로 제공  
 */
function download(url, fileName, options = {}, previewTagId) {
  const fetchOptions = {
    method: 'get',
    responseType: 'blob',
    onDownloadProgress: function (progressEvent) {
        //const currentProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        //console.log('progress:',currentProgress);
    },
    ...options
  }

  return fetch(url, fetchOptions)
    .then((response) => {
      //console.log(response)
      // 미리보기 기능 
      if( previewTagId ) {
        var image = document.getElementById(previewTagId);
        image.addEventListener("load", function (evt) {
            URL.revokeObjectURL(evt.target.src);
        });
        image.src = window.URL.createObjectURL(new Blob([response.data]));
        image.parentElement.classList.toggle("hidden");
      // 다운로드 기능 
      } else {
        // IE
        if ( navigator.msSaveBlob ) {
          navigator.msSaveBlob( new Blob([response.data]), fileName );
        // 기타 브라우저
        } else {
          // Anchor tag 
          const blobURL = window.URL.createObjectURL(new Blob([response.data]));
          const downloadAnchorTag = document.createElement('a');
          downloadAnchorTag.href = blobURL;
          downloadAnchorTag.setAttribute('download', fileName);
          document.body.appendChild(downloadAnchorTag);

          // download
          downloadAnchorTag.click();

          // tag 제거
          document.body.removeChild(downloadAnchorTag);
          window.URL.revokeObjectURL(blobURL);
        }
      }
    });
}

export function downloadFile(url, filename, stateName, caller, showNotificationFunc) {
  if( !url || !filename ) {
    showNotificationFunc(
      '잘못된 요청입니다.',
      'warning'
    );
    return;
  }

  // 현재 다운로드중인 파일인 지 체크
  if( caller.state[stateName] )  {
    showNotificationFunc(
      "이미 동일한 파일을 다운로드 진행중입니다.",
      "warning"
    );
    return;
  }
//console.log("download start")
  caller.setState({ [stateName]: true });
  download(url, filename, {})
    .catch((error) => {
      console.error('download - Error :', error.message);
      showNotificationFunc(
        '다운로드를 실패하였습니다.',
        'warning'
      );
      return;
    })
    .then(() => {
      caller.setState({ [stateName]: false });
      //console.log("download end")

    });
}

/**
 * 파일명이 길 때 중간에 ...처리
 */
export function makeShortenedFilename(filename) {
  if( !filename )
    return "";

  filename = filename.normalize('NFC');
  if( filename.length > 30 ) {
    return filename.substr(0, 15) + '...' + filename.substring(filename.length-7, filename.length);;
  } else {
    return filename;
  }
}
